import { render, staticRenderFns } from "./CloseOutlineSVG.vue?vue&type=template&id=0ed4f313&"
import script from "./CloseOutlineSVG.vue?vue&type=script&lang=js&"
export * from "./CloseOutlineSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports